import React from "react";
import { SectionTitle } from "@/components/home/SectionTitle";

const ABSTRACT_IMAGE = "https://images.unsplash.com/photo-1772991274497-47229106e6db?w=1600&q=80";
const CREST_IMAGE = "https://images.unsplash.com/photo-1709227040897-14f6c6687086?w=1600&q=80";

export const HomePillars = ({ t }) => (
  <section data-testid="home-why" className="bg-[#F4F0E8]">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 sm:py-24 lg:py-32 grid grid-cols-1 lg:grid-cols-12 gap-10">
      <div className="lg:col-span-4">
        <SectionTitle kicker={t.home.whyKicker} title={t.home.whyTitle} />
        <p className="text-[#5E6470] leading-relaxed max-w-md">{t.common.tagline}</p>
      </div>
      <div className="lg:col-span-8 grid grid-cols-1 md:grid-cols-3 gap-8">
        {t.home.pillars.map((p, i) => (
          <div key={p.k} data-testid={`pillar-${i}`} className="border-t border-[#0F1B2D]/15 pt-8">
            <div className="font-display text-[#C4A46A] text-xl">0{i + 1}</div>
            <h3 className="mt-4 font-display text-[#0F1B2D] text-xl tracking-tight">{p.k}</h3>
            <p className="mt-4 text-[#5E6470] text-sm leading-relaxed">{p.d}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const HomeProcess = ({ t }) => (
  <section data-testid="home-process" className="bg-[#0F1B2D] relative grain">
    <div
      className="absolute inset-0 opacity-20"
      style={{ backgroundImage: `url(${ABSTRACT_IMAGE})`, backgroundSize: "cover", backgroundPosition: "center", mixBlendMode: "luminosity" }}
    />
    <div className="relative max-w-[1400px] mx-auto px-6 lg:px-12 py-16 sm:py-24 lg:py-32">
      <SectionTitle kicker={t.home.processKicker} title={t.home.processTitle} dark />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-12 mt-4">
        {t.home.processSteps.map((s, i) => (
          <div key={s.t} data-testid={`process-step-${i}`} className="flex gap-6">
            <div className="font-display text-[#C4A46A] text-3xl leading-none">{s.n}</div>
            <div>
              <h3 className="font-display text-white text-xl tracking-tight">{s.t}</h3>
              <p className="mt-3 text-white/65 text-sm leading-relaxed">{s.d}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const HomeFamily = ({ t }) => (
  <section data-testid="home-family" className="bg-[#0F1B2D] text-white">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 sm:py-24 lg:py-32 grid grid-cols-1 lg:grid-cols-12 gap-10">
      <div className="lg:col-span-5">
        <SectionTitle kicker={t.common.tagline} title={t.home.familyTitle} dark />
        <div className="mt-8 aspect-[4/5] bg-cover bg-center" style={{ backgroundImage: `url(${CREST_IMAGE})` }} aria-hidden />
      </div>
      <div className="lg:col-span-7 grid grid-cols-1 md:grid-cols-2 gap-10">
        {t.home.familyItems.map((it, i) => (
          <div key={it.t} data-testid={`family-item-${i}`}>
            <div className="font-display text-[#C4A46A]">0{i + 1}</div>
            <h3 className="mt-4 font-display text-white text-xl lg:text-2xl tracking-tight">{it.t}</h3>
            <span className="gold-rule mt-4 block" />
            <p className="mt-5 text-white/75 text-[15px] leading-relaxed">{it.d}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
